import { EventBus } from '@/plugins/event-bus.js'

export default {
  get(key, callback) {
    //Get Initial data
    callback(window.VUE_CLI_EXPORTS.plugins.Store.getters[key])

    //Update data when it is changed
    EventBus.$on(key, () => {
      callback(window.VUE_CLI_EXPORTS.plugins.Store.getters[key])
    })
  },

  // used for a one-time getting of a store value
  getOnce(key) {
    return window.VUE_CLI_EXPORTS.plugins.Store.getters[key]
  },

  getWithParam(key, param, callback) {
    //Get Initial data
    callback(window.VUE_CLI_EXPORTS.plugins.Store.getters[key](param))

    //Update data when it is changed
    EventBus.$on(key, () => {
      callback(window.VUE_CLI_EXPORTS.plugins.Store.getters[key](param))
    })
  },

  removeListeners(listeners) {
    listeners.forEach((listener) => {
      EventBus.$off(listener)
    })
  },

  commit(key, value) {
    return window.VUE_CLI_EXPORTS.plugins.Store.commit(key, value)
  },

  dispatch(key, arg) {
    return window.VUE_CLI_EXPORTS.plugins.Store.dispatch(key, arg)
  },
}
